// ISO-8601 YYYY-mm-DDThh:mm:ss+hhmm
export function fmtDate(iso) {
  if (!iso && iso === '') {
    return ''
  }
  let date = new Date(iso)
  // console.log('[DEBUG] iso: "' + iso + '"')
  if (iso == null || iso === '') {
    return 'n/a'
  }
  const offset = new Date().getTimezoneOffset()
  date.setMinutes(date.getMinutes() - offset)
  // date = date.toISOString()
  return date.toLocaleString() // date.substr(0, 10) + ' ' + date.substr(11, 5)
}

export function statusColor (status) {
  if (status === 'good') {
    return '#81d886'
  }
  if (status === 'warning') {
    return '#ffea3d'
  }
  if (status === 'critical') {
    return '#ef4357'
  }
  return '#bdbdbd'
}

